var _templateObject;
function cov_nf1h30zob() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Loader/FullScreenLoader.tsx";
  var hash = "767bf38c0f12dffe4885af64f895a06a1fd2ccca";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Loader/FullScreenLoader.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 14
        },
        end: {
          line: 22,
          column: 1
        }
      },
      "1": {
        start: {
          line: 29,
          column: 50
        },
        end: {
          line: 46,
          column: 1
        }
      },
      "2": {
        start: {
          line: 30,
          column: 2
        },
        end: {
          line: 45,
          column: 9
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 29,
            column: 50
          },
          end: {
            line: 29,
            column: 51
          }
        },
        loc: {
          start: {
            line: 30,
            column: 2
          },
          end: {
            line: 45,
            column: 9
          }
        },
        line: 30
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 29,
            column: 69
          },
          end: {
            line: 29,
            column: 92
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 29,
            column: 81
          },
          end: {
            line: 29,
            column: 92
          }
        }],
        line: 29
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "767bf38c0f12dffe4885af64f895a06a1fd2ccca"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_nf1h30zob = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_nf1h30zob();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { keyframes } from '@chakra-ui/system';
import { Box, Flex } from "../index.mjs";
import colors from "../../theme/novo/foundations/colors.mjs";
import { Logo } from "../Logo/index.mjs";
const pulse = (cov_nf1h30zob().s[0]++, keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t0% {\n\t\ttransform: scale(0.9);\n\t}\n\n\t60% {\n\t\ttransform: scale(1);\n\t}\n\n\t100% {\n\t\ttransform: scale(0.9);\n\t}\n"]))));
/**
 * Loader that fills the entire screen with a pulsing Opendoor logo
 */
cov_nf1h30zob().s[1]++;
export const FullScreenLoader = _ref => {
  let {
    containerProps,
    logoColor = (cov_nf1h30zob().b[0][0]++, 'neutrals0')
  } = _ref;
  cov_nf1h30zob().f[0]++;
  cov_nf1h30zob().s[2]++;
  return /*#__PURE__*/React.createElement(Flex, _extends({
    bg: "neutrals0",
    flexDirection: "column",
    width: "100vw",
    height: "100vh",
    justifyContent: "center",
    alignItems: "center",
    p: [5, 7, null, 8],
    background: colors.brandBlue600,
    "data-testid": "full-screen-loader"
  }, containerProps), /*#__PURE__*/React.createElement(Box, {
    animation: "".concat(pulse, " 2s infinite")
  }, /*#__PURE__*/React.createElement(Logo, {
    variant: "secondary",
    height: 100,
    color: logoColor
  })));
};